import AjaxClass from "../modules/Forms/Validation/ajaxClass";

const modalDown = document.querySelector('.modal-down');
const closeModal = document.querySelector('.close');
let isSubmitting = false;

$(document).on('click', '.card-book', function() {
    localStorage.setItem('catalogId', $(this).attr('catalogId'));
    modalDown.classList.add('open-modal');
});

$(document).on('click', '.close', function() {
    modalDown.classList.remove('open-modal');
});

formValidation();

function formValidation() {

    $(document)
        .off('submit', '#download-form')
        .on('submit', '#download-form', function (event) {

            event.preventDefault();

            if (isSubmitting) return;

            const form = $(this);
            let isValid = true;

            form.find('input, select, textarea').each(function () {
                const field = $(this);

                if (field.prop('required') && !field.val()) {
                    field.addClass('is-invalid').removeClass('is-valid');
                    isValid = false;
                } else {
                    field.addClass('is-valid').removeClass('is-invalid');
                }
            });

            const check = $('#check');

            if (!check.is(':checked')) {
                check.addClass('is-invalid').removeClass('is-valid');
                isValid = false;
            } else {
                check.addClass('is-valid').removeClass('is-invalid');
            }

            if (!isValid) return;

            isSubmitting = true;

            sendForm(form);
        });

    $(document)
        .off('input change', 'input, select, textarea')
        .on('input change', 'input, select, textarea', function () {

            if ($(this).val() || $(this).is(':checked')) {
                $(this).addClass('is-valid').removeClass('is-invalid');
            } else {
                $(this).addClass('is-invalid').removeClass('is-valid');
            }
        });
}

function sendForm(form) {

    let type = 'POST';
    let url = form.attr('action');
    let dataType = 'json';
    let formData = form.serialize();

    const modalError = document.getElementById('error-message-forms');
    const modalDescription = document.querySelector('#error-message-forms .description');

    const submitButton = form.find('button[type="submit"]');
    submitButton.prop('disabled', true);

    class Contact extends AjaxClass {

        successFunction(data) {

            if (data.status === true) {

                form.trigger("reset");
                submitButton.prop('disabled', false);

                let catalogId = localStorage.getItem('catalogId');

                if (catalogId && $("#" + catalogId).length) {
                    $("#" + catalogId).get(0).click();
                }

                $(closeModal).trigger('click');

            } else {

                modalDescription.innerHTML = data.txt;
                modalError.classList.add("open-modal");
                submitButton.prop('disabled', false);
            }

            isSubmitting = false;
        }

        errorFunction(xhr, textStatus, errorThrown) {

            modalDescription.innerHTML = "Ocorreu um erro. Tente novamente mais tarde.";

            if (errorThrown === 'Too Many Requests' || xhr.responseText === 'Too Many Requests') {
                modalDescription.innerHTML = "Muitas tentativas! Aguarde um minuto antes de tentar novamente.";
            }

            modalError.classList.add("open-modal");
            submitButton.prop('disabled', false);
            isSubmitting = false;
        }
    }

    let ajax = new Contact(form, type, url, dataType, formData);
    ajax.send();
}
